import React, { useEffect, useMemo, useState } from 'react'
import { INITIAL_VALUES, toFormValues } from './form'
import { useErrorHandling } from 'context/errorHandling'
import { SuccessDialog } from 'components/Shared/Dialogs'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { createUserGroup, fetchUserGroup, fetchUserGroupMembers } from 'services/UserGroupsService'
import UserGroupsForm from 'components/UserGroups/UserGroupsForm/UserGroupsForm'
import { Loader } from 'components/Shared/Loader'
import { USER_GROUP_CREATE } from 'context/auth'

export function UserGroupsCreateForm (props) {
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [copiedGroup, setCopiedGroup] = useState()
  const [copiedMembers, setCopiedMembers] = useState([])
  const [loading, setLoading] = useState(false)

  const { t } = useTranslation()
  const history = useHistory()
  const { handleError } = useErrorHandling()

  const idOfCopiedGroup = props.location.state?.idOfCopiedGroup

  useEffect(() => {
      if (idOfCopiedGroup) {
        fetchUserGroup(idOfCopiedGroup)
          .then(setCopiedGroup)
          .catch(handleError)
        fetchUserGroupMembers(idOfCopiedGroup)
          .then(setCopiedMembers)
          .catch(handleError)
      }
    }, [idOfCopiedGroup, handleError]
  )

  const handleSubmit = (newGroup, handleMembersChange) => {
    createUserGroup(newGroup)
      .then(createdGroup => {
        setLoading(true)
        handleMembersChange(createdGroup.id)
          .then(() => setSuccessDialogOpen(true))
          .catch(handleError)
          .then(() => setLoading(false))
      })
      .catch(handleError)
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    history.push('/user-groups')
  }

  //memo required to prevent clearing selection on opening member select dialog
  const initialMembers = useMemo(() => idOfCopiedGroup ? copiedMembers : [], [idOfCopiedGroup, copiedMembers])

  return (
    <>
      {loading && <Loader/>}
      <SuccessDialog
        content="userGroups.form.create.onSuccessMessage"
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
      />
      {!idOfCopiedGroup || (copiedGroup && copiedMembers) ? <UserGroupsForm
        onSubmit={handleSubmit}
        initialValues={idOfCopiedGroup ? toFormValues(copiedGroup) : INITIAL_VALUES}
        initialMembers={initialMembers}
        title={t('userGroups.form.create.title')}
        isCreateForm
        requiredPrivileges={[USER_GROUP_CREATE]}
      /> : <Loader/>
      }
    </>
  )
}
